import { Image } from "primereact/image";
import React, { useState, useEffect, useRef } from "react";
import { TieredMenu } from "primereact/tieredmenu";
import { OverlayPanel } from "primereact/overlaypanel";
import { ScrollPanel } from "primereact/scrollpanel";
import { Link, useNavigate } from "react-router-dom";
import { API, Auth, DataStore, Predicates, SortDirection, Storage, graphqlOperation } from "aws-amplify";
import { reactLocalStorage } from "reactjs-localstorage";
import NewAgreementLogo from "../../../src/assets/images/new_agreement_logo.svg";
import * as alertify from "alertifyjs";
import { InputText } from "primereact/inputtext";
import "alertifyjs/build/css/alertify.css";
import ProfileIMG from "../../../src/assets/images/profile.png";
import ValidateEmail from "../../components/common/ValidateEmail";
import OnlyNumbers from "../../components/common/OnlyNumers";
import moment from "moment";
import { BUSINESS_ENTITY, PSA_Status, PSA_Designation } from "../../helper/enum";
import { PSAConsultant, PSAParty, PSATransactionCycle, PSAPartyDocument, PSADocuments } from "../../models";
import { Dialog } from "primereact/dialog";
import { toast } from "react-toastify";
import { useParams } from "react-router-dom";
import { useSearchParams } from "react-router-dom/dist";
import { useFormik } from "formik";
import awsmobile from "../../aws-exports";
import AWS from "aws-sdk";
import Termsandcondition from "./terms_conditions";
import Preview from "./preview_agreement";
import * as mutations from "../../graphql/mutations";
import { Button } from "primereact/button";

import { handleNotificationsOnStatusChangeforPSA } from "../../components/actions/notficationActions";
import { ProgressSpinner } from "primereact/progressspinner";

import { GetAWSObjectURL, UploadFileOnS3, GetAWSObjectDelete } from "../../helper/aws";
import { graphQLGetAllData, graphQLFindRecordById } from "../../helper/commonfunctions";



export default function PSAConsultants() {
  const menu = useRef(null);
  const notification = useRef(null);
  const mail = useRef(null);
  var myNavigation = useNavigate();
  const [party, setParty] = useState("");
  const [isPartyNameChange, setIsPartyNameChange] = useState(false);
  const [clientId, setClientId] = useState("");
  const [pocName, setPocName] = useState("");
  const [pocNumber, setPocNumber] = useState("");
  const [email, setEmail] = useState("1");
  const [ssn, setSSN] = useState("");
  const [employerId, setEmployerId] = useState("");
  const [typeBE, setTypeBE] = useState("");

  const [otherTypeBE, setOtherTypeBE] = useState("");

  const [title, setTitle] = useState("");
  const [license, setLicense] = useState("");
  //Address
  const [state, setState] = useState("");
  const [city, setCity] = useState("");
  const [address, setAddress] = useState("");
  const [zip, setZip] = useState("");
  const [reportId, setReportId] = useState("1");
  // const { reportId } = useParams();
  const [pleaseWaitBtn, setPleaseWaitBtn] = useState(false);
  const [readOnly, setReadOnly] = useState(false);
  const [isVerified, setIsVerified] = useState(false);
  const [confirmVisible, setConfirmVisible] = useState(false);
  const [buttonClicked, setButtonClicked] = useState(false);
  const [showField, setShowField] = useState(false);
  const [OTP, setOTP] = useState();
  const [docList, setDocList] = useState([]);
  const [fileName, setFileName] = useState([]);
  const loggedUserId = reactLocalStorage.get("loggedUserId");
  const [tab1, setTab1] = useState(true);
  const [tab2, setTab2] = useState(false);
  const [tab3, setTab3] = useState(false);
  const [psaDetail, setPSADetail] = useState("");
  const [strs, setStrs] = useState();
  const [calpers, setCalpers] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [checked, setChecked] = useState(false);
  const [checked1, setChecked1] = useState(false);
  const [checked2, setChecked2] = useState(false);
  const [checked3, setChecked3] = useState(false);
  const [checked4, setChecked4] = useState(false);
  const [checked5, setChecked5] = useState(false);
  const [partyDocuments, setPartyDocuments] = useState([]);
  const [isDataExist, setIsDataExist] = useState(false);
  const [originalData, setOriginalData] = useState();

  const [selectedFileName, setSelectedFileName] = useState("");
  const [selectedFileNames, setSelectedFileNames] = useState("");

  const [selectedFileNameData, setSelectedFileNameData] = useState("");
  const [selectedFileNamesData, setSelectedFileNamesData] = useState("");

  const [value, setValue] = useState("");
  const [RejectReport, setRejectReport] = useState(false);
  const [RejectReport_Send, setRejectReport_Send] = useState(false);

  const [initiatorDocuments, setInitiatorDocuments] = useState([]);

  const s3 = new AWS.S3({
    accessKeyId: process.env.REACT_APP_AWS_AccessKeyId,
    signatureVersion: 'v4',
    region: process.env.REACT_APP_AWS_Region,
    secretAccessKey: process.env.REACT_APP_AWS_SecretAccessKey
  });

  const bucketName = process.env.REACT_APP_AWS_Bucket;


  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {},
    // initialValues:{},
    validate: data => {
      let errors = {};
      return errors;
    },
    onSubmit: data => {
      console.log("🚀 ~ file: index.js:65 ~ PSAConsultants ~ data:", data.otp);
      console.log("🚀 ~ file: index.js:66 ~ PSAConsultants ~ OTP:", OTP);
      console.log("🚀 ~ file: index.js:66 ~ PSAConsultants ~ data.otp:", data.otp);
      if (OTP || data.otp) {
        if (OTP == data.otp) {
          // BindList();
          setIsVerified(true);
        } else {
          toast.error("OTP not matched.");
        }
      } else {
        toast.error("Please Enter OTP.");
      }

    }
  });

  let [searchParams, setSearchParams] = useSearchParams();
  let { id } = useParams();





  async function OpenDocument(filePath) {
    console.log(filePath, "filePath");
    filePath = filePath.replace("public/", "");
    filePath = "public/" + filePath;
    let filePathURL = await GetAWSObjectURL(filePath);

    //const imageBlob = await fetch(filePathURL).then(response => response.blob());
    //const url = window.URL.createObjectURL(imageBlob);

    const link = document.createElement("a");
    link.href = filePathURL;
    link.target = "_blank";
    // link.download = "";
    document.body.appendChild(link);
    link.click();
    link.remove();
  }

  async function removeFromS3(filePath) {
    filePath = filePath.replace("public/", "");
    filePath = "public/" + filePath;
    await GetAWSObjectDelete(fileName);

  }
  //onclick remove inquiry document
  const onClickRemoveDoc = async index => {
    let data = [...docList];
    const record = data[index];

    if (data.length > 0) {
      data.splice(index, 1);
      setDocList(data);
      const filePath = `psaconsultant/${record.reportId}/document/psaparty/${record.filename}`;
      await removeFromS3(filePath);
      // const deleteFiles = await DataStore.delete(PSAPartyDocument, record?.id);
      const deleteFiles = await API.graphql(
        graphqlOperation(mutations.deletePSAPartyDocument, {
          input: {
            report_id: record?.id
          }
        })
      );
      toast.success("File Removed successfully");
    }
  };

  const checkPhoneNumber = e => {
    // if (OnlyNumbers(e.target.value)) {
    //   setPocNumber(e.target.value);
    // } else {
    //   setPocNumber("");
    //   //toast.error('Enter only alphabets to firstname.'); return;
    // }
    setPocNumber(e);
  };

  const saveSelectedReport = async reportId => {
    console.log("🚀 ~ file: index.js:183 ~ saveSelectedReport ~ party: 👍👍👍👍", party);
    console.log("🚀 ~ file: index.js:182 ~ saveSelectedReport ~ psaDetail: 👍👍👍👍", psaDetail);


    // if (psaDetail.submittedTo === "" || party === "" || party === null) {
    //   toast.error("Please enter PSA Consultant's Name");
    //   return;
    // }
    //else if (clientId === '' || clientId === null ) { toast.error('Please enter clientId'); return; }
    // else if (email === "" || email === null) {
    //   toast.error("Please enter email");
    //   return;
    // }
    // else if (pocName === '' || pocName === null) { toast.error('Please enter poc name'); return; }
    // else if (pocNumber === '' || pocNumber === null) { toast.error('Please enter poc number'); return; }
    // else if (employerId === '' || employerId === null) { toast.error('Please enter employer Id'); return; }
    // else if (ssn === '' || ssn === null) { toast.error('Please enter Social Security Number'); return; }

    // const original = await DataStore.query(PSAConsultant, (c) => c.id("eq", reportId));
    // const originalPSA = await DataStore.query(PSAConsultant, c => c.id.eq(reportId));
    const originalPSA = await graphQLFindRecordById("getPSAConsultant", reportId);
    console.log("🚀 ~ file: index.js:209 ~ saveSelectedReport ~ originalPSA: 🕑😋😂🎈", originalPSA);

    // const updatedData = await DataStore.save(
    // PSAConsultant.copyOf(original, updated => {
    // updated.status = 'PENDING_PSA';

    // })
    // );
    // console.log(originalPSA[0]);
    //return
    alertify.confirm(
      "Confirmation",
      "Do you want to save?",
      async function () {
        setPleaseWaitBtn(true);

        if (isDataExist) {
          // const updatedPSAConsultParty2 = await DataStore.save(
          //   PSAParty.copyOf(originalData?.[0], updated => {
          //     // updated.party = formData?.submittedTo;

          //     //update Party details
          //     updated.party = party ? party : psaDetail.submittedTo;
          //     updated.pocName = pocName;
          //     updated.clientId = clientId;
          //     updated.email = email;
          //     updated.pocNumber = pocNumber;
          //     updated.employerID = employerId;
          //     updated.ssn = ssn;
          //     updated.typeBE = typeBE === BUSINESS_ENTITY.O ? otherTypeBE : typeBE;
          //     updated.state = state;
          //     updated.address = address;
          //     updated.city = city;
          //     updated.zip = zip;
          //     updated.title = title;
          //     updated.license = license;
          //     // updated.psaConsultantId= reportId;
          //     updated.strs = strs;
          //     updated.calpers = calpers;
          //   })
          // );

          const updatedPSAConsultParty2 = await API.graphql(
            graphqlOperation(mutations.updatePSAParty, {
              input: {
                id: originalData[0]?.id,
                _version: originalData[0]?._version,
                party: party ? party : psaDetail.submittedTo,
                pocName: pocName,
                clientId: clientId,
                email: email,
                pocNumber: pocNumber,
                employerID: employerId,
                ssn: ssn,
                typeBE: typeBE === BUSINESS_ENTITY.O ? otherTypeBE : typeBE,
                state: state,
                address: address,
                city: city,
                zip: zip,
                title: title,
                license: license,
                // psaConsultantId: reportId,
                strs: strs,
                calpers: calpers
              }
            })
          );
          console.log("🚀 ~ file: index.js:241 ~ updatedPSAConsultParty2:", updatedPSAConsultParty2);
        } else {
          // var PSAParty1 = await DataStore.save(
          //   new PSAParty({
          //     // party: psaDetail.submittedTo ? psaDetail.submittedTo : party,
          //     party: party ? party : psaDetail.submittedTo,
          //     pocName: pocName,
          //     clientId: clientId,
          //     email: email,
          //     pocNumber: pocNumber,
          //     employerID: employerId,
          //     ssn: ssn,
          //     // otherTypeBE: otherTypeBE,
          //     typeBE: typeBE === BUSINESS_ENTITY.O ? otherTypeBE : typeBE,
          //     // typeBE: typeBE,
          //     state: state,
          //     address: address,
          //     // filename: selectedFileName,
          //     // filename2: selectedFileNames,
          //     city: city,
          //     zip: zip,
          //     dateOfApprove: moment().toISOString(),
          //     title: title,
          //     license: license,
          //     psaConsultantId: reportId,
          //     strs: strs,
          //     calpers: calpers
          //   })
          // );

          var createdPSAParty1 = await API.graphql(
            graphqlOperation(mutations.createPSAParty, {
              input: {
                party: party ? party : psaDetail.submittedTo,
                pocName: pocName,
                clientId: clientId,
                email: email,
                pocNumber: pocNumber,
                employerID: employerId,
                ssn: ssn,
                // otherTypeBE: otherTypeBE,
                // typeBE: typeBE === BUSINESS_ENTITY.O ? otherTypeBE : typeBE,
                // typeBE: typeBE,
                state: state,
                address: address,
                // filename: selectedFileName,
                // filename2: selectedFileNames,
                city: city,
                zip: zip,
                // dateOfApprove: moment().toISOString(),
                title: title,
                license: license,
                psaConsultantId: reportId,
                strs: strs,
                calpers: calpers
              }
            })
          );
          var PSAParty1 = createdPSAParty1?.data?.createPSAParty;
          console.log("🚀 new PSAParty1", PSAParty1);
        }


        //update consultant name in PSA
        // const updatedPSAConsult = await DataStore.save(
        //   PSAConsultant.copyOf(originalPSA[0], updated => {
        //     updated.submittedTo = party;
        //   })
        // );

        const updatedPSAConsult = await API.graphql(
          graphqlOperation(mutations.updatePSAConsultant, {
            input: {
              id: originalPSA.id,
              _version: originalPSA._version,
              submittedTo: party
            }
          })
        );

        console.log("updatedPSAConsult-1", updatedPSAConsult);
        console.log("PSAParty1-1", PSAParty1);
        if (PSAParty1) {
          // const original = await DataStore.query(PSAParty, PSAParty1?.id);
          //const original = await graphQLFindRecordById("getPSAParty", PSAParty1?.id);

          const original = await graphQLGetAllData("listPSAParties", [{ psaConsultantId: { eq: PSAParty1?.psaConsultantId } }]);

          // if (docList.length && docList[0].filename) {
          //   //file upload
          //   let transNameFile = docList[0].filename.replace(/\s+/g, '_');
          //   let id = PSAParty1?.id;
          //   // const filePath = "public/psaconsultant/" + id + "/document/" + transNameFile;
          //   // const filePath = "PSAParty/" + id + "/document/" + transNameFile;
          //   const filePath = "psaconsultant/" + reportId + "/document/psaparty/" + transNameFile;

          //   //const res = await UploadFileOnS3(file[0], filePath).catch(error => toast.error(error));

          //   const res = await Storage.put(filePath, docList[0].file, {
          //     progressCallback(progress) { }
          //   });
          //   if (res) {
          //     formik.setFieldValue("filename", filePath);
          //     toast.success("File uploaded Successfully");
          //   } else {
          //     toast.error("File is not Uploaded Successfully");
          //   }


          //   const docSavedData = await DataStore.save(
          //     new PSAPartyDocument({
          //       reportId: reportId,
          //       filename: transNameFile,
          //       filepath: filePath
          //     })
          //   );

          //   //  console.log("savedData", docSavedData);

          //   // const updatedData = await DataStore.save(
          //   // PSAParty.copyOf(original, updated => {
          //   // updated.filePath = filePath;
          //   // })
          //   // );
          //   // console.log("🚀 ~ file: index.js:168 ~ updatedData:", updatedData);
          // }

          for (let i = 0; i < docList.length; i++) {
            const fileData = docList[i];
            if (fileData.filename) {
              // File upload logic
              const transNameFile = fileData.filename.replace(/\s+/g, "_");
              const filePath = `public/psaconsultant/${reportId}/document/psaparty/${transNameFile}`;

              try {
                // const res = await Storage.put(filePath, fileData.file, {
                // progressCallback(progress) {}
                // });



                const key = filePath;

                const params = {
                  Bucket: bucketName,
                  Key: key,
                  Expires: 60, // URL expiration time in seconds
                  ContentType: fileData.type, // Adjust the content type as needed
                };

                const signedUrl = s3.getSignedUrl('putObject', params);
                console.log(signedUrl)
                fetch(signedUrl, {
                  method: 'PUT',
                  body: fileData.file,
                  headers: {
                    'Content-Type': fileData.type,
                  },
                })
                  .then(response => {
                    console.log(response, "response")
                    if (!response.ok) {
                      throw new Error('Failed to upload file');
                    }
                    formik.setFieldValue("filename", filePath);
                    console.log('File uploaded successfully');
                  })
                  .catch(error => {
                    console.error('Error uploading file:', error);
                  });

                // if (res) {
                // formik.setFieldValue("filename", filePath);

                // toast.success("File uploaded Successfully");
                // } else {
                // toast.error("File is not Uploaded Successfully");
                // }

                // const docSavedData = await DataStore.save(
                //   new PSAPartyDocument({
                //     reportId: reportId,
                //     filename: transNameFile,
                //     filepath: filePath
                //   })
                // );

                const docSavedData = await API.graphql(
                  graphqlOperation(mutations.createPSAPartyDocument, {
                    input: {
                      reportId: reportId,
                      filename: transNameFile,
                      filepath: filePath
                    }
                  })
                );

                // Handle success or error for each file separately
                // if (docSavedData) {
                //   toast.success(`File ${transNameFile} saved Successfully`);
                // } else {
                //   toast.error(`File ${transNameFile} is not saved Successfully`);
                // }
              } catch (error) {
                // Handle any errors during file upload or saving
                console.error(`Error processing file ${fileData.filename}: ${error}`);
              }
            }
          }




          //Save EDD and W9 File
          let asarry = [];
          let firstFile = "";
          if (selectedFileName) {
            let transNameFile1 = selectedFileName.replace(/^.*[\\\/]/, "");
            firstFile = transNameFile1;
            const filePath1 = "public/psaconsultant/" + reportId + "/document/psaparty/" + transNameFile1;
            // try{
            // const res = await Storage.put(filePath1, selectedFileNameData, {
            // progressCallback(progress) {}
            // });
            // }catch(e){
            // console.log("file upload error ",e)
            // }

            // try{
            // const res = await UploadFileOnS3(selectedFileNameData, filePath1).catch(error => console.log(error));
            // }catch(e){
            //console.log("file upload error ",e)
            // }
            console.log(selectedFileNameData, "selectedFileNameData")
            //const signedUrl = await Storage.get(filePath1, { expires: 60 });



            const key = filePath1;

            const params = {
              Bucket: bucketName,
              Key: key,
              Expires: 60, // URL expiration time in seconds
              ContentType: selectedFileNameData.type, // Adjust the content type as needed
            };

            const signedUrl = s3.getSignedUrl('putObject', params);
            console.log(signedUrl)
            fetch(signedUrl, {
              method: 'PUT',
              body: selectedFileNameData,
              headers: {
                'Content-Type': selectedFileNameData.type,
              },
            })
              .then(response => {
                console.log(response, "response")
                if (!response.ok) {
                  throw new Error('Failed to upload file');
                }
                console.log('File uploaded successfully');
              })
              .catch(error => {
                console.error('Error uploading file:', error);
              });

            asarry.push(transNameFile1);
            // const updatedEdd = await DataStore.save(
            //   PSAParty.copyOf(original, updated => {
            //     updated.filename = transNameFile1;
            //   })
            // );
            const updatedEdd = await API.graphql({
              query: mutations.updatePSAParty,
              variables: {
                input: {
                  id: original[0]?.id,
                  _version: original[0]?._version,
                  filename: transNameFile1
                }
              }
            });
          }

          if (selectedFileNames) {
            let transNameFile2 = selectedFileNames.replace(/^.*[\\\/]/, "");
            const filePath2 = "public/psaconsultant/" + reportId + "/document/psaparty/" + transNameFile2;
            // try{
            // const res = await Storage.put(filePath2, selectedFileNamesData, {
            // progressCallback(progress) {}
            // });
            // }catch(e){
            // console.log("file upload error ",e)
            // }
            // try{
            // const res = await UploadFileOnS3(selectedFileNamesData, filePath2).catch(error => console.log(error));
            // }catch(e){
            /////////console.log("file upload error ",e)
            // }

            console.log(selectedFileNamesData, "selectedFileNamesData")
            //const signedUrl = await Storage.get(filePath2, { expires: 60 });



            const key = filePath2;

            const params = {
              Bucket: bucketName,
              Key: key,
              Expires: 60, // URL expiration time in seconds
              ContentType: selectedFileNamesData.type, // Adjust the content type as needed
            };

            const signedUrl = await s3.getSignedUrl('putObject', params);
            console.log(signedUrl, "signedUrl")
            fetch(signedUrl, {
              method: 'PUT',
              body: selectedFileNamesData,
              headers: {
                'Content-Type': selectedFileNamesData.type,
              },
            })
              .then(response => {
                console.log(response, "response")
                if (!response.ok) {
                  throw new Error('Failed to upload file');
                }
                console.log('File uploaded successfully');
              })
              .catch(error => {
                console.error('Error uploading file:', error);
              });




            asarry.push(transNameFile2);
            console.log(asarry.toString(), "assas");
            // const updatedW9 = await DataStore.save(
            //   PSAParty.copyOf(original, updated => {
            //     updated.filename2 = transNameFile2;
            //     updated.w9File = firstFile; //asarry.toString();
            //     updated.filename = firstFile;
            //   })
            // );
            const updatedW9 = await API.graphql(
              graphqlOperation(mutations.updatePSAParty, {
                input: {
                  id: original[0]?.id,
                  _version: original[0]?._version,
                  filename2: transNameFile2,
                  w9File: firstFile,
                  filename: firstFile
                }
              })
            );
          }


        }

        console.log("reportId-1", reportId);
        // const original = await DataStore.query(PSATransactionCycle, c => c.report_Id.eq(reportId), {
        //   sort: s => s.createdAt(SortDirection.ASCENDING)
        // });

        //const original = await graphQLFindRecordById("getPSATransactionCycle", reportId);
        let original = await graphQLGetAllData("listPSATransactionCycles", [{ report_Id: { eq: reportId } }])
        original = original.sort((b, a) => (a.createdAt).localeCompare(b.createdAt));

        // let newOriginal = original.length ? original[original.length - 1] : original[0];
        let newOriginal = original;
        console.log(newOriginal);

        let secondApprover = originalPSA?.budgetClerk;
        let thirdApprover = originalPSA?.hrConsultant;

        if (original) {
          var updatePsaTransactionCycleData = await API.graphql(
            graphqlOperation(mutations.updatePSATransactionCycle, {
              input: {
                id: original[0].id,
                _version: original[0]._version,
                isApproved: true,
              }
            }));
        }

        if (updatePsaTransactionCycleData?.data) {
          setButtonClicked(true);
          // after we add another row for save report id for third Approver (Budget Cleark).

          const addNewRowForRMReasponse = await API.graphql(
            graphqlOperation(mutations.createPSATransactionCycle, {
              input: {
                report_Id: reportId,
                from_Employee_Id: "1",
                to_Employee_Id: secondApprover ? secondApprover : thirdApprover,
                status: secondApprover
                  ? PSA_Status.PENDING_FOR_APPROVAL_BUDGET_CLERK
                  : PSA_Status.PENDING_FOR_APPROVAL_HR_CONSULTANT_CLEARANCE_VERIFICATION,
                isApproved: false,
                remark: "",
                date: moment().format("YYYY-MM-DD"),
                dateTime: moment().toISOString(),
                designation: secondApprover
                  ? PSA_Designation.BUDGET_CLERK
                  : PSA_Designation.HR_EXCECUTIVE_SECREATARY_APPROVER
              }
            })
          );
        }

        // await DataStore.save(
        //   PSATransactionCycle.copyOf(newOriginal, updated => {
        //     updated.isApproved = true;
        //   })
        // ).then(async () => {
        //   setButtonClicked(true);
        //   // after we add another row for save report id for third Approver (Budget Cleark).
        //   const addNewRowForRMReasponse = await DataStore.save(
        //     new PSATransactionCycle({
        //       report_Id: reportId,
        //       from_Employee_Id: "1",
        //       to_Employee_Id: secondApprover ? secondApprover : thirdApprover,
        //       status: secondApprover
        //         ? PSA_Status.PENDING_FOR_APPROVAL_BUDGET_CLERK
        //         : PSA_Status.PENDING_FOR_APPROVAL_HR_CONSULTANT_CLEARANCE_VERIFICATION,
        //       isApproved: false,
        //       remark: "",
        //       date: moment().format("YYYY-MM-DD"),
        //       dateTime: moment().toISOString(),
        //       designation: secondApprover
        //         ? PSA_Designation.BUDGET_CLERK
        //         : PSA_Designation.HR_EXCECUTIVE_SECREATARY_APPROVER
        //     })
        //   );
        // });

        setConfirmVisible(true);
        setButtonClicked(true);
        //then we remove otp field from PsaConsultant table.
        // const updatedPost = await DataStore.save(
        //   PSAConsultant.copyOf(originalPSA, updated => {
        //     updated.otp = null;
        //     updated.dateOfApprove = moment().format("YYYY-MM-DD HH:mm:ss");
        //   })
        // );
        const updatedPost = await API.graphql(
          graphqlOperation(mutations.updatePSAConsultant, {
            input: {
              id: originalPSA.id,
              _version: originalPSA._version,
              otp: null,
              dateOfApprove: moment().format("YYYY-MM-DD HH:mm:ss")
            }
          })
        );

        if (updatedPost) {
          toast.success("Data & File Uploaded Successfully.");
        }

        await handleNotificationsOnStatusChangeforPSA(
          "PSA Consultant Accepted",
          reportId,
          "PERSONAL_SERVICE_AGREEMENT",
          originalPSA.createdBy,
          originalPSA.createdBy,
          ""
        );

        await handleNotificationsOnStatusChangeforPSA(
          secondApprover
            ? PSA_Status.PENDING_FOR_APPROVAL_BUDGET_CLERK
            : PSA_Status.PENDING_FOR_APPROVAL_HR_CONSULTANT_CLEARANCE_VERIFICATION,
          reportId,
          "PERSONAL_SERVICE_AGREEMENT",
          secondApprover ? secondApprover : thirdApprover,
          originalPSA.createdBy,
          ""
        );
        setPleaseWaitBtn(false);
        await Auth.signOut({ global: false });
        reactLocalStorage.clear();
        myNavigation("/");
      },

      function () { }
    );

    // await DataStore.save(
    //   PSAParty.copyOf(original, updated => {
    //     updated.party = party;
    //     updated.pocname = pocName;
    //     updated.clientId = clientId;
    //     updated.email = email;
    //     updated.pocCN1 = pocNumber;
    //     updated.employerID = employerId;
    //     updated.ssn = ssn;
    //     updated.typeBE = typeBE;
    //     updated.state = state;
    //     updated.address = address;
    //     updated.city = city;
    //     updated.zip = zip;
    //     updated.title =title;

    //   })
    // )

    //setButtonClicked(true);
  };

  const handleSubmit = () => {
    alertify.confirm(
      // "Confirmation",
      "Report Reject",
      // "Do you want to reject?",
      "Report Rejected successfully",
      async function () {
        // const original = await DataStore.query(PSATransactionCycle, c => c.report_Id.eq(reportId), {
        //   sort: s => s.createdAt(SortDirection.ASCENDING)
        // });

        //const original = await graphQLFindRecordById("getPSATransactionCycle", reportId);

        let original = await graphQLGetAllData("listPSATransactionCycles", [{ report_Id: { eq: reportId } }])
        original = original.sort((a, b) => (a.createdAt).localeCompare(b.createdAt));


        //console.log(original,"original");

        let newOriginal = original[original.length - 1];
        //let newOriginal = original;

        // await DataStore.save(
        //   PSATransactionCycle.copyOf(newOriginal, updated => {
        //     updated.isApproved = false;
        //     updated.status = PSA_Status.REJECTED;
        //     updated.remark = value;
        //   })
        // );

        await API.graphql({
          query: mutations.updatePSATransactionCycle,
          variables: {
            input: {
              id: newOriginal.id,
              _version: newOriginal._version,
              isApproved: false,
              status: PSA_Status.REJECTED,
              remark: value
            }
          }
        });
        //then we remove otp field from PsaConsultant table.
        // const originalPSA = await DataStore.query(PSAConsultant, c => c.id.eq(reportId));
        const originalPSA = await graphQLFindRecordById("getPSAConsultant", reportId);
        if (originalPSA) {
          // const updatedPost = await DataStore.save(
          //   PSAConsultant.copyOf(originalPSA, updated => {
          //     updated.otp = null;
          //   })
          // );
          const updatedPost = await API.graphql({
            query: mutations.updatePSAConsultant,
            variables: {
              input: {
                id: originalPSA.id,
                _version: originalPSA._version,
                otp: null
              }
            }
          });
          // const updatedPost = await DataStore.save(
          //   PSAConsultant.copyOf(originalPSA[0], updated => {
          //     updated.otp = null;
          //   })
          // );

          if (updatedPost) {
            toast.success("Rejected Successfully.");
          }
        }

        //PSA REJECT NOTIFICATION Send
        await handleNotificationsOnStatusChangeforPSA(
          "PSA Consultant Rejected",
          reportId,
          "PERSONAL_SERVICE_AGREEMENT",
          originalPSA.createdBy,
          originalPSA.createdBy,
          value
        );
        // await handleNotificationsOnStatusChangeforPSA(
        //   "PSA Consultant Rejected",
        //   reportId,
        //   "PERSONAL_SERVICE_AGREEMENT",
        //   originalPSA[0].createdBy,
        //   originalPSA[0].createdBy,
        //   value
        // );

        setButtonClicked(true);
        await Auth.signOut({ global: false });
        reactLocalStorage.clear();
        myNavigation("/");
      },
      function () { }
    );
  };
  const rejectSelectedReport = async reportId => {
    setRejectReport(true);
    // alertify.confirm(
    //   "Confirmation",
    //   "Do you want to reject?",
    //   async function () {
    //     const original = await DataStore.query(PSATransactionCycle, c => c.report_Id.eq(reportId), {
    //       sort: s => s.createdAt(SortDirection.ASCENDING)
    //     });
    //     //console.log(reportId)
    //     let newOriginal = original[original.length - 1];

    //     await DataStore.save(
    //       PSATransactionCycle.copyOf(newOriginal, updated => {
    //         updated.isApproved = false;
    //         updated.status = PSA_Status.REJECTED;
    //       })
    //     )
    //     //then we remove otp field from PsaConsultant table.
    //     const originalPSA = await DataStore.query(PSAConsultant, (c) => c.id.eq(reportId));
    //     if (originalPSA) {
    //       const updatedPost = await DataStore.save(
    //         PSAConsultant.copyOf(originalPSA[0], updated => {
    //           updated.otp = null
    //         })
    //       );

    //       if (updatedPost) {
    //         toast.success("Rejected Successfully.");
    //       }
    //     }

    //     //PSA REJECT NOTIFICATION Send
    //     await handleNotificationsOnStatusChangeforPSA(
    //       "PSA Consultant Rejected",
    //       reportId,
    //       "PERSONAL_SERVICE_AGREEMENT",
    //       originalPSA[0].createdBy,
    //       originalPSA[0].createdBy,
    //       "");


    //     setButtonClicked(true);
    //     await Auth.signOut({ global: false });
    //     reactLocalStorage.clear();
    //     myNavigation("/");
    //   },
    //   function () { }
    // );
  };

  function validateFileExtension(file_field, allowedExtensions) {
    let flag = false;
    let extension = file_field.substr(file_field.lastIndexOf(".") + 1).toLowerCase();
    if (allowedExtensions.indexOf(extension) === -1) {
      flag = true;
    }
    return flag;
  }

  async function uploadDocuments(e) {
    let file = e.target.files;

    for (let i = 0; i < file?.length; i++) {
      let file_field = file[i].name;
      let allowedExtensions = ["pdf"];
      let flag = false;

      flag = validateFileExtension(file_field, allowedExtensions);
      if (flag) {
        e.target.value = null;
        //setFileName([]);
        toast.error("Please Select Valid file Format. Only " + allowedExtensions.join(", ") + " are allowed.");
        return;
      } else {
        setFileName(prev => [...prev, e.target.files[i].name]);
        let data = [];
        //for (let i = 0; i < file.length; i++) {
        const fileObj = file[i];
        const newData = { filename: fileObj.name, file: fileObj, type: fileObj.type };
        data.push(newData);
        if (file.length > 0) {
          setDocList(prev => [...prev, ...data]);
        }

        //data.push(newData);
        //}
      }
    }

    //setDocList(data);
  }


  const footerContentforPSA = (
    <div className="text-center">
      <button
        className="border border-[#1E1E1E] text-[#1E3E5A] px-4 py-2 rounded"
        onClick={() => {
          setConfirmVisible(false);
        }}
      >
        Close
      </button>
    </div>
  );

  const handleOptionChange = event => {
    console.log("event.target.value123 :-", event.target.value);
    const value = event.target.value;
    setTypeBE(value);
    setShowField(value === BUSINESS_ENTITY.O); // Set showField to true if 'option2' is selected, otherwise false.
  };

  const items = [
    // {
    //   label: "View profile",
    //   icon: "gusd-user",
    //   url: "/initiatorprofile"
    // },
    {
      label: "Change Password",
      icon: "gusd-lock",
      url: "/changepassword"
    },
    {
      label: "Switch Account",
      icon: "gusd-switch-account",
      items: [
        {
          label: "Admin"
        },
        {
          label: "Initiator"
        },
        {
          label: "Approver"
        },
        {
          label: "Payroll"
        },
        {
          label: "PSA Consultant"
        },
        {
          label: "Initiators After Board Meeting"
        }
      ]
    },
    {
      separator: true
    },
    {
      label: "Log out",
      icon: "gusd-logout",
      command: async () => {
        await Auth.signOut({ global: false });
        reactLocalStorage.clear();
        myNavigation("/");
      }
    }
  ];

  useEffect(() => {
    if (otherTypeBE) {
      setShowField(true)
    } else {
      setShowField(false)
    }
  }, [otherTypeBE])


  const BindList = async reportId => {
    // const original = await DataStore.query(PSAParty, c => c.psaConsultantId.eq(reportId));
    // const original = await graphQLFindRecordById("getPSAParty", reportId);
    const original = await graphQLGetAllData("listPSAParties", [{ psaConsultantId: { eq: reportId } }]);
    console.log("🚀 ~ file: index.js:737 ~ BindList ~ original:", original);
    setIsDataExist(original?.length > 0 ? true : false);
    setOriginalData(original);
    setParty(original?.[0]?.party);
    setClientId(original?.[0]?.clientId);
    setPocName(original?.[0]?.pocName);
    setPocNumber(original?.[0]?.pocNumber);
    setEmail(original?.[0]?.email);
    setSSN(original?.[0]?.ssn);
    setEmployerId(original?.[0]?.employerID);
    setTypeBE(original?.[0]?.typeBE);
    setTitle(original?.[0]?.title);
    setLicense(original?.[0]?.license);
    setState(original?.[0]?.state);
    setCity(original?.[0]?.city);
    setAddress(original?.[0]?.address);
    setZip(original?.[0]?.zip);

    //add condition if initiator select other option
    if (
      original?.[0]?.typeBE != "Corporation" &&
      original?.[0]?.typeBE != "Partnership" &&
      original?.[0]?.typeBE != "Sole Partnership" &&
      original?.[0]?.typeBE != "Individual"
    ) {
      setShowField(true);
      setOtherTypeBE(original?.[0]?.typeBE);
    }

    // const originalPSA = await DataStore.query(PSAConsultant, reportId);
    const originalPSA = await graphQLFindRecordById("getPSAConsultant", reportId);
    console.log("🚀 ~ file: index.js:764 ~ BindList ~ originalPSA:", originalPSA);
    console.log("originalPSA", originalPSA);
    let obj = {
      id: reportId,
      agreementDate: originalPSA?.agreementDate,
      amount: originalPSA?.amount,
      services: originalPSA?.services,
      effectiveDate: originalPSA?.effectiveDate,
      expirationDate: originalPSA?.expireDate,
      typeOfBusinessEntityAandN: originalPSA?.typeBE,
      submittedTo: originalPSA?.submittedTo,
      referenceNo: originalPSA?.referenceNo,
      purchaseOrderNo: originalPSA?.purchaseOrderNo,
      addendumNo: originalPSA?.addendumNo,
      typeBE: originalPSA?.typeBE,
      accountNumber: originalPSA?.accountNo,
      businessEntity: originalPSA?.businessEntity && originalPSA?.businessEntity?.split(","),
      BoardItem: originalPSA?.boardItem,
      submittedCompletedFormTo: originalPSA?.submittedCompletedFormTo,
      // typeBE2:pSAPartyData.typeBE,
      // PSA Consultant details
      typeOfBusinessEntityPartyDetails: originalPSA?.typeOfBusinessEntityPartyDetails,
      title: originalPSA?.assignmentTitle,
      licenseNumber: originalPSA?.licenseNumber,
      addressPSa: originalPSA?.addressPSa,
      psaDate: originalPSA?.psaDate,
      contactNumber: originalPSA?.contactNumber,
      fax: originalPSA?.fax,
      //Tax Identification Details
      socialSecurityNumber: originalPSA?.socialSecurityNumber,
      employerIdentification: originalPSA?.employerIdentification,
      //Gusd Detailes
      gusdDate: originalPSA?.gusdDate,
      dateOfBoardMeeting: originalPSA?.dateofboard,
      boardItem: originalPSA?.boardItem,
      pageItem: originalPSA?.pageItem,
      superintendentAssistent: originalPSA?.superintendentAssistent,
      psaEmail: originalPSA?.psaEmail
    };

    // if (original) {
    //   setParty(original?.[0]?.party);
    // } else {
    //   setParty(originalPSA?.submittedTo);
    // }
    console.log(party, "originalPSA--");

    setPSADetail(obj);
    setParty(obj?.submittedTo);

    // setParty(obj?.submittedTo);
    setEmail(obj?.psaEmail);
    //PSAPARTY files
    const getPSAPartyDocuments = () => {
      return new Promise(async (resolve, reject) => {
        // let PSAPartyDocumentsData = await DataStore.query(PSAPartyDocument, c => c?.reportId.eq(reportId), {
        //   sort: s => s.createdAt(SortDirection.ASCENDING)
        // });
        //const PSAPartyDocumentsData = await graphQLFindRecordById("getPSAPartyDocument", reportId);
        let PSAPartyDocumentsData = await graphQLGetAllData("listPSAPartyDocuments", [{ reportId: { eq: reportId } }])
        PSAPartyDocumentsData = PSAPartyDocumentsData.sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt))

        resolve(PSAPartyDocumentsData);
      });
    };

    getPSAPartyDocuments().then(res => {
      setPartyDocuments(res);
    });

    setInitiatorDocuments([]);
    if (reportId) {
      const getPSADocuments = () => {
        return new Promise(async (resolve, reject) => {
          // let PSADocumentsData = await DataStore.query(PSADocuments, c => c?.reportId.eq(reportId), {
          //   sort: s => s.createdAt(SortDirection.ASCENDING)
          // });
          //const PSADocumentsData = await graphQLFindRecordById("getPSADocuments", reportId);

          let PSADocumentsData = await graphQLGetAllData("listPSADocuments", [{ reportId: { eq: reportId } }])
          PSADocumentsData = PSADocumentsData.sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt))

          resolve(PSADocumentsData);
        });
      };

      getPSADocuments().then(res => {
        setInitiatorDocuments(res);
      });
    }


    if (original !== null) {
      setReadOnly(true);
    }
  };

  useEffect(() => {
    setReportId(id);
    // BindList(id);
  }, [isVerified]);

  useEffect(() => {
    BindList(id);
    if (OTP) {
      setIsLoading(true);
    }

    const fetchData = async () => {
      try {
        // Perform an asynchronous operation, for example, fetching data from an API
        const sub = await graphQLFindRecordById("getPSAConsultant", id);

        setOTP(sub?.otp);
        setTimeout(() => {
          setIsLoading(false);
        }, 3000);
      } catch (error) {
        // Handle errors here
        console.error("Error fetching data:", error);
      }
    };

    // Call the async function
    fetchData();

    return () => { };
  }, []);

  const partyName = e => {
    if (!isPartyNameChange || party === undefined) {
      setParty(psaDetail.submittedTo);
    } else {
      setParty(e.target.value);
    }
  };

  console.log("Party e.target.value", party);

  return (
    <>
      {/*Header*/}
      <Dialog
        header="Header"
        className="RejectReport"
        visible={RejectReport}
        style={{ width: "30vw" }}
        onHide={() => setRejectReport(false)}
      >
        {/*col*/}
        <div className="p-[22px] space-y-[14px]">
          {/*col*/}
          <div>
            <div className="text-[#101828] font-bold text-base -tracking-[0.36px]">Reject Report</div>
          </div>
          <div className="space-y-1 mb-5">
            <div className="text-[#344054] font-medium text-[14px] mb-1">
              Enter the reason for rejection<span className="text-[red] pl-0.2"></span>
              <span className="text-[red] pl-0.2">*</span>
            </div>
            <InputText
              value={value}
              onChange={e => setValue(e.target.value)}
              placeholder="Enter the Reason for Rejection"
              style={{
                border: "1px",
                borderStyle: "solid",
                borderRadius: "5px",
                borderColor: "#E4E7EC",
                background: "#fff",
                width: "100%"
              }}
            />
          </div>
        </div>
        {/*col*/}
        {/*col*/}
        <div className="flex items-center justify-center gap-4 mb-4">
          <div
            className="text-white bg-[#113699] py-2 px-4 text-center rounded-lg w-[100px] cursor-pointer mt-5"
            onClick={handleSubmit}
          >
            Submit
          </div>
          <button
            onClick={() => setRejectReport(false)}
            type="button"
            className="text-[#344054] font-medium text-sm text-center xl:py-[0.521vw] py-[8px] xl:px-[0.781vw] px-[14px] border border-[#D0D5DD] bg-white Shadow_xs rounded-lg space-x-2 cursor-pointer mt-5"
            id="add-family-cancel-btn"
            style={{ marginRight: "12px" }}
          >
            Cancel
          </button>
        </div>
        {/*col*/}
      </Dialog>
      <div className="w-full header_gradiant">
        <div className="dashboardHeader xl:py-[0.833vw] py-[16px]">
          <div className="px-[15px] xl:px-[3.125vw]">
            <div className="flex items-center justify-between">
              <div>
                <img src={NewAgreementLogo} width={470} className="xl:w-[24.479vw] xl:h-[4.583vw]" />
              </div>
              <div className="flex items-center divide-x divide-[#E0E0E0] gap-x-[20px] lg:gap-x-[40px] xl:gap-x-[2.083vw]">
                {/* <div className="space-x-[20px] lg:space-x-[40px] xl:space-x-[2.083vw] relative">
                  <Link to={""} onClick={e => notification.current.toggle(e)}>
                    <i className="gusd-notification text-[#667085] text-[20px] xl:text-[1.250vw]"></i>
                  </Link>

                  <OverlayPanel ref={notification} showCloseIcon className="notification">
                    <div className="text-[#344054] font-semibold text-[18px] xl:text-[0.938vw] mb-[8px] xl:mb-[0.417vw]">
                      Notifications
                    </div>
                    <ScrollPanel style={{ width: "100%", height: "23.438vw" }} className="custombar1">
                      <div className="grid grid-cols-1 divide-y">
                        <div className="col py-[18px] xl:py-[0.625vw]">
                          <div className="flex items-center justify-between space-x-[8px] xl:space-x-[0.417vw]">
                            <div className="flex items-start space-x-[10px] xl:space-x-[0.521vw]">
                              <div>
                                <i className="gusd-chat text-[18px] xl:text-[1.042vw] text-[#667085]"></i>
                              </div>
                              <div className="content">
                                <div className="text-[14px] xl:text-[0.729vw] text-[#344054] font-semibold">
                                  New coment in parties tab
                                </div>
                                <div className="text-[14px] xl:text-[0.729vw] text-[#344054]">
                                  changed the input name of employee from “Kalvin” to “Samston”.
                                </div>
                                <div className="text-[#667085] text-[12px] xl:text-[0.625vw]">11:15 am, 14th Feb.</div>
                              </div>
                            </div>
                            <div className="dot">
                              <i className="gusd-dot text-[16px] xl:text-[0.833vw] text-[#FDB022]"></i>
                            </div>
                          </div>
                        </div>
                        <div className="col py-[18px] xl:py-[0.625vw]">
                          <div className="flex items-center justify-between space-x-[8px] xl:space-x-[0.417vw]">
                            <div className="flex items-start space-x-[10px] xl:space-x-[0.521vw]">
                              <div>
                                <i className="gusd-close-circle-bold text-[18px] xl:text-[1.042vw] text-[#667085]"></i>
                              </div>
                              <div className="content">
                                <div className="text-[14px] xl:text-[0.729vw] text-[#344054] font-semibold">
                                  Report rejected
                                </div>
                                <div className="text-[14px] xl:text-[0.729vw] text-[#344054]">
                                  Information Missing for "David", Please review and resubmit.
                                </div>
                                <div className="text-[#667085] text-[12px] xl:text-[0.625vw]">11:15 am, 14th Feb.</div>
                              </div>
                            </div>
                            <div className="dot">
                              <i className="gusd-dot text-[16px] xl:text-[0.833vw] text-[#FDB022]"></i>
                            </div>
                          </div>
                        </div>
                        <div className="col py-[18px] xl:py-[0.625vw]">
                          <div className="flex items-center justify-between space-x-[8px] xl:space-x-[0.417vw]">
                            <div className="flex items-start space-x-[10px] xl:space-x-[0.521vw]">
                              <div>
                                <i className="gusd-pluse-circle text-[18px] xl:text-[1.042vw] text-[#667085]"></i>
                              </div>
                              <div className="content">
                                <div className="text-[14px] xl:text-[0.729vw] text-[#344054] font-semibold">
                                  New report for review
                                </div>
                                <div className="text-[14px] xl:text-[0.729vw] text-[#344054]">
                                  Information Missing for "David", Please review and resubmit.
                                </div>
                                <div className="text-[#667085] text-[12px] xl:text-[0.625vw]">11:15 am, 14th Feb.</div>
                              </div>
                            </div>
                            <div className="dot">
                              <i className="gusd-dot text-[16px] xl:text-[0.833vw] text-[#FDB022]"></i>
                            </div>
                          </div>
                        </div>
                        <div className="col py-[18px] xl:py-[0.625vw]">
                          <div className="flex items-center justify-between space-x-[8px] xl:space-x-[0.417vw]">
                            <div className="flex items-start space-x-[10px] xl:space-x-[0.521vw]">
                              <div>
                                <i className="gusd-close-circle-bold text-[18px] xl:text-[1.042vw] text-[#667085]"></i>
                              </div>
                              <div className="content">
                                <div className="text-[14px] xl:text-[0.729vw] text-[#344054] font-semibold">
                                  Report rejected
                                </div>
                                <div className="text-[14px] xl:text-[0.729vw] text-[#344054]">
                                  Information Missing for "David", Please review and resubmit.
                                </div>
                                <div className="text-[#667085] text-[12px] xl:text-[0.625vw]">11:15 am, 14th Feb.</div>
                              </div>
                            </div>
                            <div className="dot">
                              <i className="gusd-dot text-[16px] xl:text-[0.833vw] text-[#FDB022]"></i>
                            </div>
                          </div>
                        </div>
                        <div className="col py-[18px] xl:py-[0.625vw]">
                          <div className="flex items-center justify-between space-x-[8px] xl:space-x-[0.417vw]">
                            <div className="flex items-start space-x-[10px] xl:space-x-[0.521vw]">
                              <div>
                                <i className="gusd-close-circle-bold text-[18px] xl:text-[1.042vw] text-[#667085]"></i>
                              </div>
                              <div className="content">
                                <div className="text-[14px] xl:text-[0.729vw] text-[#344054] font-semibold">
                                  Report rejected
                                </div>
                                <div className="text-[14px] xl:text-[0.729vw] text-[#344054]">
                                  Information Missing for "David", Please review and resubmit.
                                </div>
                                <div className="text-[#667085] text-[12px] xl:text-[0.625vw]">11:15 am, 14th Feb.</div>
                              </div>
                            </div>
                            <div className="dot">
                              <i className="gusd-dot text-[16px] xl:text-[0.833vw] text-[#FDB022]"></i>
                            </div>
                          </div>
                        </div>
                        <div className="col py-[18px] xl:py-[0.625vw]">
                          <div className="flex items-center justify-between space-x-[8px] xl:space-x-[0.417vw]">
                            <div className="flex items-start space-x-[10px] xl:space-x-[0.521vw]">
                              <div>
                                <i className="gusd-close-circle-bold text-[18px] xl:text-[1.042vw] text-[#667085]"></i>
                              </div>
                              <div className="content">
                                <div className="text-[14px] xl:text-[0.729vw] text-[#344054] font-semibold">
                                  Report rejected
                                </div>
                                <div className="text-[14px] xl:text-[0.729vw] text-[#344054]">
                                  Information Missing for "David", Please review and resubmit.
                                </div>
                                <div className="text-[#667085] text-[12px] xl:text-[0.625vw]">11:15 am, 14th Feb.</div>
                              </div>
                            </div>
                            <div className="dot">
                              <i className="gusd-dot text-[16px] xl:text-[0.833vw] text-[#FDB022]"></i>
                            </div>
                          </div>
                        </div>
                        <div className="col py-[18px] xl:py-[0.625vw]">
                          <div className="flex items-center justify-between space-x-[8px] xl:space-x-[0.417vw]">
                            <div className="flex items-start space-x-[10px] xl:space-x-[0.521vw]">
                              <div>
                                <i className="gusd-close-circle-bold text-[18px] xl:text-[1.042vw] text-[#667085]"></i>
                              </div>
                              <div className="content">
                                <div className="text-[14px] xl:text-[0.729vw] text-[#344054] font-semibold">
                                  Report rejected
                                </div>
                                <div className="text-[14px] xl:text-[0.729vw] text-[#344054]">
                                  Information Missing for "David", Please review and resubmit.
                                </div>
                                <div className="text-[#667085] text-[12px] xl:text-[0.625vw]">11:15 am, 14th Feb.</div>
                              </div>
                            </div>
                            <div className="dot">
                              <i className="gusd-dot text-[16px] xl:text-[0.833vw] text-[#FDB022]"></i>
                            </div>
                          </div>
                        </div>
                      </div>
                    </ScrollPanel>
                  </OverlayPanel>
                </div> */}
                {/* <div className="pl-[20px] lg:pl-[40px] xl:pl-[2.083vw]">
                  <div
                    className="flex items-center space-x-[20px] xl:space-x-[1.042vw] cursor-pointer"
                    onClick={e => menu.current.toggle(e)}
                  >
                    <Image
                      src={ProfileIMG}
                      width={"48"}
                      height={"48"}
                      imageClassName="rounded-full w-[48px] h-[48px] xl:w-[2.500vw] xl:h-[2.500vw] object-cover userImg"
                    />

                    <i className="gusd-arrow-down text-[#667085] text-[14px] xl:text-[0.729vw]"></i>
                  </div>
                </div>
                <TieredMenu model={items} popup ref={menu} className="profileDropdown" /> */}
              </div>
            </div>
          </div>
        </div>
      </div>
      {/*Header*/}
      {isVerified ? (
        <div className="grid grid-cols-12">
          {/*Col-4*/}
          <div className="col-span-3">
            <div className="xl:p-[2.083vw] p-[20px] blur_gradiant h-screen">
              <div className="text-[#344054] font-normal text-sm xl:text-[0.729vw]">GUSD New Service Agreement</div>
              {/* <div className="flex items-center space-x-2 text-[#101828] font-medium text-lg xl:text-[1.042vw]">
                <span>Agreement 10102</span> <i className="base_icon"></i>
              </div> */}

              <div className="xl:mt-[1.667vw] mt-[25px]">
                <div className="xl:space-y-[1.667vw] space-y-[30px]">
                  <Link
                    to={""}
                    onClick={() => {
                      // setTab1(true);
                      // setTab2(false);
                      // setTab3(false);
                    }}
                    className={
                      tab1
                        ? "flex items-center gap-2 text-[#2252D3] font-semibold text-sm xl:text-[0.833vw] active-tabs"
                        : "flex items-center gap-2 text-[#667085] font-semibold text-sm xl:text-[0.833vw] active-tabs"
                    }
                  >
                    <span
                      className={
                        tab1
                          ? "w-[40px] xl:w-[2.083vw] h-[40px] xl:h-[2.083vw] rounded-full bg-[#2252D3] text-white flex items-center justify-center"
                          : "w-[40px] xl:w-[2.083vw] h-[40px] xl:h-[2.083vw] rounded-full bg-[#F6F7FA] border-[3px] border-[#989CA5] text-white flex items-center justify-center"
                      }
                    >
                      <i className={tab1 ? "listIcon partydetails" : "listIcon"}></i>
                    </span>{" "}
                    <span>PSA Consultant Details</span>
                  </Link>

                  <Link
                    to={""}
                    onClick={() => {
                      // setTab1(false);
                      // setTab2(true);
                      // setTab3(false);
                    }}
                    className={
                      tab2
                        ? "flex items-center gap-2 text-[#2252D3] font-semibold text-sm xl:text-[0.833vw] active-tabs"
                        : "flex items-center gap-2 text-[#667085] font-semibold text-sm xl:text-[0.833vw] active-tabs"
                    }
                  >
                    <span
                      className={
                        tab2
                          ? "w-[40px] xl:w-[2.083vw] h-[40px] xl:h-[2.083vw] rounded-full bg-[#2252D3] text-white flex items-center justify-center"
                          : "w-[40px] xl:w-[2.083vw] h-[40px] xl:h-[2.083vw] rounded-full bg-[#F6F7FA] border-[3px] border-[#989CA5] text-white flex items-center justify-center"
                      }
                    >
                      <i className={tab2 ? "RightlistIcon right-icon listIcon partydetails" : "listIcon"}></i>
                    </span>{" "}
                    <span>Terms & Conditions</span>
                  </Link>
                  <Link
                    to={""}
                    onClick={() => {
                      // setTab1(false);
                      // setTab2(false);
                      // setTab3(true);
                    }}
                    className={
                      tab3
                        ? "flex items-center gap-2 text-[#2252D3] font-semibold text-sm xl:text-[0.833vw] active-tabs"
                        : "flex items-center gap-2 text-[#667085] font-semibold text-sm xl:text-[0.833vw] active-tabs"
                    }
                  >
                    <span
                      className={
                        tab3
                          ? "w-[40px] xl:w-[2.083vw] h-[40px] xl:h-[2.083vw] rounded-full bg-[#2252D3] text-white flex items-center justify-center"
                          : "w-[40px] xl:w-[2.083vw] h-[40px] xl:h-[2.083vw] rounded-full bg-[#F6F7FA] border-[3px] border-[#989CA5] text-white flex items-center justify-center"
                      }
                    >
                      <i className={tab3 ? "RightlistIcon right-icon listIcon partydetails" : "listIcon"}></i>
                    </span>{" "}
                    <span>Preview</span>
                  </Link>
                </div>
              </div>
            </div>
          </div>
          {/*Col-4*/}

          {tab1 ? (
            <>
              {/*Col-8*/}
              <div className="col-span-9">
                <div className="lg:px-[5.573vw] px-[80px] xl:py-[1.667vw] py-[30px]">
                  {/*form*/}
                  <div
                    className="text-[#000000] font-bold xl:text-[1.406vw] text-[24px]"
                    data-aos="fade-down"
                    data-aos-duration="700"
                    data-aos-delay="500"
                  >
                    PSA Consultant Details
                  </div>

                  <div
                    className="xl:mt-[1.667vw] mt-[25px]"
                    data-aos="fade-down"
                    data-aos-duration="700"
                    data-aos-delay="500"
                  >
                    {/* <form> */}
                    <div className="grid md:grid-cols-2 xl:gap-[1.250vw] gap-[20px]">
                      {/*col*/}
                      <div className="space-y-1">
                        <div>
                          <label className="text-[#344054] font-medium text-xs">
                            PSA Consultant's Name<span className="text-[red] pl-0.2">*</span>
                          </label>
                        </div>
                        <div>
                          <input
                            type="text"
                            onChange={e => {
                              partyName(e);
                              setIsPartyNameChange(true);
                            }}
                            // defaultValue={psaDetail.submittedTo ? psaDetail.submittedTo : party}
                            defaultValue={party ? party : psaDetail.submittedTo}
                            placeholder="Type here"
                            className="bg-white border border-[#E4E7EC] rounded-[5px] xl:h-[2.292vw] h-[40px] xl:p-[0.625vw] p-[10px] placeholder:text-[#667085] placeholder:text-xs w-full leading-10"
                          />
                        </div>
                      </div>
                      {/*col*/}
                      <div className="space-y-1">
                        <div>
                          <label className="text-[#344054] font-medium text-xs">
                            PSA Consultant's Email<span className="text-[red] pl-0.2">*</span>
                          </label>
                        </div>
                        <div className="relative">
                          <input
                            type="text"
                            onChange={e => setEmail(e.target.value)}
                            // value={email}
                            value={psaDetail?.psaEmail}
                            disabled
                            placeholder="Type Email address"
                            className="bg-white border border-[#E4E7EC] rounded-[5px] xl:h-[2.292vw] h-[40px] xl:py-[0.625vw] py-[10px] xl:pr-[0.625vw] pr-[10px] pl-8 placeholder:text-[#667085] placeholder:text-xs w-full leading-10"
                          />
                          <i className="mailicon absolute left-3 top-3"></i>
                        </div>
                      </div>
                      <div className="space-y-1">
                        <div>
                          <label className="text-[#344054] font-medium text-xs">Phone</label>
                        </div>
                        <div className="relative">
                          <input
                            type="text"
                            onChange={e => {
                              const numericValue = e.target.value.replace(/[^0-9]/g, "");
                              // checkPhoneNumber(e);
                              checkPhoneNumber(numericValue);
                            }}
                            maxLength={15}
                            value={pocNumber}
                            placeholder="Type contact number"
                            className="bg-white border border-[#E4E7EC] rounded-[5px] xl:h-[2.292vw] h-[40px] xl:py-[0.625vw] py-[10px] xl:pr-[0.625vw] pr-[10px] pl-8 placeholder:text-[#667085] placeholder:text-xs w-full leading-10"
                          />
                          <i className="Poc_con_no absolute left-3 top-3"></i>
                        </div>
                      </div>
                      <div className="space-y-1">
                        <div>
                          <label className="text-[#344054] font-medium text-xs">Fax</label>
                        </div>
                        <div className="relative">
                          <input
                            type="text"
                            onChange={e => setPocName(e.target.value)}
                            value={pocName}
                            placeholder="Type here"
                            className="bg-white border border-[#E4E7EC] rounded-[5px] xl:h-[2.292vw] h-[40px] xl:p-[0.625vw] p-[10px] placeholder:text-[#667085] placeholder:text-xs w-full leading-10"
                          />
                        </div>
                      </div>
                      {/* <div className="space-y-1">
                        <div>
                          <label className="text-[#344054] font-medium text-xs">Client ID</label>
                        </div>
                        <div>
                          <input
                            type="text"
                            onChange={e => setClientId(e.target.value)}
                            value={clientId}
                            placeholder="Type here"
                            className="bg-white border border-[#E4E7EC] rounded-[5px] xl:h-[2.292vw] h-[40px] xl:p-[0.625vw] p-[10px] placeholder:text-[#667085] placeholder:text-xs w-full leading-10"
                          />
                        </div>
                      </div> */}
                      {/*col*/}
                      <div className="space-y-1">
                        <div>
                          <label className="text-[#344054] font-medium text-xs">Employer Identification</label>
                        </div>
                        <div className="relative">
                          <input
                            type="text"
                            onChange={e => setEmployerId(e.target.value)}
                            value={employerId}
                            placeholder="Type here"
                            className="bg-white border border-[#E4E7EC] rounded-[5px] xl:h-[2.292vw] h-[40px] xl:p-[0.625vw] p-[10px] placeholder:text-[#667085] placeholder:text-xs w-full leading-10"
                          />
                        </div>
                      </div>

                      {/*col*/}

                      {/*col*/}

                      {/*col*/}

                      <div className="space-y-1">
                        <div>
                          <label className="text-[#344054] font-medium text-xs">Social Security Number</label>
                        </div>
                        <div className="relative">
                          <input
                            type="text"
                            onChange={e => setSSN(e.target.value)}
                            value={ssn}
                            placeholder="Type here"
                            className="bg-white border border-[#E4E7EC] rounded-[5px] xl:h-[2.292vw] h-[40px] xl:py-[0.625vw] py-[10px] xl:pr-[0.625vw] pr-[10px] pl-8 placeholder:text-[#667085] placeholder:text-xs w-full leading-10"
                          />
                          <i className="security_no absolute left-3 top-3"></i>
                        </div>
                      </div>
                      {/*col*/}

                      {/*col*/}
                    </div>
                    <div className="xl:mt-[1.250vw] mt-[20px] mb-[0.25rem]">
                      <label className="text-[#344054] font-medium text-xs">Type of Business Entity</label>
                    </div>
                    <div className="flex flex-wrap items-center xl:gap-[1.042vw] gap-[20px]">
                      <div className="flex items-center">
                        <input
                          type="radio"
                          name="radio1"
                          onChange={handleOptionChange}
                          checked={typeBE == "Individual" ? true : false}
                          value={BUSINESS_ENTITY.I}
                          id="radioButton1"
                          class="h-4 w-4"
                        />
                        <label
                          htmlFor="radioButton1"
                          className="pl-2 text-xs xl:text-[0.729vw] font-medium text-[#344054]"
                        >
                          Individual
                        </label>
                      </div>
                      <div className="flex items-center">
                        <input
                          type="radio"
                          name="radio1"
                          id="radioButton2"
                          onChange={handleOptionChange}
                          checked={typeBE == "Sole Partnership" ? true : false}
                          value={BUSINESS_ENTITY.SP}
                          className="h-4 w-4"
                        />
                        <label
                          htmlFor="radioButton2"
                          className="pl-2 text-xs xl:text-[0.729vw] font-medium text-[#344054]"
                        >
                          Sole Partnership
                        </label>
                      </div>
                      <div className="flex items-center">
                        <input
                          type="radio"
                          name="radio1"
                          id="radioButton3"
                          onChange={handleOptionChange}
                          checked={typeBE == "Partnership" ? true : false}
                          value={BUSINESS_ENTITY.P}
                          className="h-4 w-4"
                        />
                        <label
                          htmlFor="radioButton3"
                          className="pl-2 text-xs xl:text-[0.729vw] font-medium text-[#344054]"
                        >
                          Partnership
                        </label>
                      </div>
                      <div className="flex items-center">
                        <input
                          type="radio"
                          name="radio1"
                          id="radioButton4"
                          onChange={handleOptionChange}
                          checked={typeBE == "Corporation" ? true : false}
                          value={BUSINESS_ENTITY.C}
                          className="h-4 w-4"
                        />
                        <label
                          htmlFor="radioButton4"
                          className="pl-2 text-xs xl:text-[0.729vw] font-medium text-[#344054]"
                        >
                          Corporation
                        </label>
                      </div>
                      <div className="flex items-center">
                        <input
                          type="radio"
                          name="radio1"
                          id="radioButton5"
                          onChange={e => {
                            handleOptionChange(e);
                            setOtherTypeBE("");
                          }}
                          // checked={typeBE == "Other" ? true : false}
                          // checked={typeBE.includes("other") ? true : false}
                          checked={
                            typeBE != "Corporation" &&
                              typeBE != "Partnership" &&
                              typeBE != "Sole Partnership" &&
                              typeBE != "Individual" &&
                              typeBE != undefined &&
                              typeBE != null
                              ? true
                              : false
                          }
                          value={BUSINESS_ENTITY.O}
                          className="h-4 w-4"
                        />
                        <label
                          htmlFor="radioButton5"
                          className="pl-2 text-xs xl:text-[0.729vw] font-medium text-[#344054]"
                        >
                          Other
                        </label>
                      </div>
                      {showField ? (
                        <div className="flex">
                          <input
                            type="text"
                            onChange={e => setOtherTypeBE(e.target.value)}
                            // onChange={e => setTypeBE(e.target.value)}
                            value={otherTypeBE}
                            // value={typeBE}
                            placeholder="Type here"
                            className="bg-white border border-[#E4E7EC] rounded-[5px] xl:h-[2.292vw] h-[40px] xl:p-[0.625vw] p-[10px] placeholder:text-[#667085] placeholder:text-xs w-[109px] leading-10"
                          />
                        </div>
                      ) : null}
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-2 xl:gap-[1.250vw] gap-[20px] xl:mt-[1.250vw] mt-[20px]">
                      {/*col*/}
                      <div className="space-y-1">
                        <div>
                          <label className="text-[#344054] font-medium text-xs">Title</label>
                        </div>
                        <div className="relative">
                          <input
                            type="text"
                            onChange={e => setTitle(e.target.value)}
                            value={title}
                            placeholder="Type here"
                            className="bg-white border border-[#E4E7EC] rounded-[5px] xl:h-[2.292vw] h-[40px] xl:p-[0.625vw] p-[10px] placeholder:text-[#667085] placeholder:text-xs w-full leading-10"
                          />
                        </div>
                      </div>
                      {/*col*/}
                      <div className="space-y-1">
                        <div>
                          <label className="text-[#344054] font-medium text-xs">Licence Number</label>
                        </div>
                        <div className="relative">
                          <input
                            type="text"
                            onChange={e => setLicense(e.target.value)}
                            value={license}
                            placeholder="Type here"
                            className="bg-white border border-[#E4E7EC] rounded-[5px] xl:h-[2.292vw] h-[40px] xl:p-[0.625vw] p-[10px] placeholder:text-[#667085] placeholder:text-xs w-full leading-10"
                          />
                        </div>
                      </div>

                      {/*col*/}
                      <div className="md:col-span-2 space-y-1">
                        <div>
                          <label className="text-[#344054] font-medium text-xs">Address</label>
                        </div>
                        <div className="grid grid-cols-2 md:grid-cols-4 xl:gap-[1.250vw] gap-[20px]">
                          <div>
                            <input
                              type="text"
                              onChange={e => setAddress(e.target.value)}
                              value={address}
                              placeholder="Street Address"
                              className="bg-white border border-[#E4E7EC] rounded-[5px] xl:h-[2.292vw] h-[40px] xl:p-[0.625vw] p-[10px] placeholder:text-[#667085] placeholder:text-xs w-full leading-10"
                            />
                          </div>
                          <div>
                            <input
                              type="text"
                              onChange={e => setCity(e.target.value)}
                              value={city}
                              placeholder="City"
                              className="bg-white border border-[#E4E7EC] rounded-[5px] xl:h-[2.292vw] h-[40px] xl:p-[0.625vw] p-[10px] placeholder:text-[#667085] placeholder:text-xs w-full leading-10"
                            />
                          </div>
                          <div>
                            <input
                              type="text"
                              onChange={e => setState(e.target.value)}
                              value={state}
                              placeholder="State"
                              className="bg-white border border-[#E4E7EC] rounded-[5px] xl:h-[2.292vw] h-[40px] xl:p-[0.625vw] p-[10px] placeholder:text-[#667085] placeholder:text-xs w-full leading-10"
                            />
                          </div>


                          <div>
                            <input
                              type="text"
                              onChange={e => setZip(e.target.value)}
                              value={zip}
                              placeholder="Postal Code"
                              className="bg-white border border-[#E4E7EC] rounded-[5px] xl:h-[2.292vw] h-[40px] xl:p-[0.625vw] p-[10px] placeholder:text-[#667085] placeholder:text-xs w-full leading-10"
                            />
                          </div>
                        </div>
                      </div>

                      <div className="col mt-6">
                        <div class="border border-dashed border-gray-500 relative">
                          <input
                            type="file"
                            name="filename"
                            multiple
                            class="cursor-pointer relative block opacity-0 w-full h-[100px] p-20 z-50"
                            onChange={e => {
                              uploadDocuments(e);
                            }}
                          />

                          {/*{docList.length > 0 &&
                            docList.map((res,index) => (
                              <div className="flex gap-2 justify-center">
                                <p className="psa-attachments-notes-remove-btn">
                                  {res.filename}
                                </p>
                                <i className="pi pi-times mt-1.5" style={{ fontSize: "11px", marginTop: "8px" }}
                                  onClick={(e) =>  { onClickRemoveDoc(index) } }
                                ></i>
                              </div>
						  ))} */}

                          <div className="text-center m-auto mt-[20px] h-[100px] overflow-auto">
                            <div className="grid grid-cols-2 md:grid-cols-2 gap-3 xl:gap-[0.250vw]">
                              {fileName.length > 0 &&
                                fileName.map(res => (
                                  <p className="psa-attachments-notes-remove-btn text-[12px] h-[30px]">
                                    {res}{" "}
                                    {
                                      <Button
                                        icon="pi pi-times"
                                        onClick={() => {
                                          setFileName(prev => {
                                            return prev.filter(res1 => {
                                              if (res1 != res) {
                                                return res1;
                                              }
                                            });
                                          });
                                        }}
                                        rounded
                                        text
                                        severity="danger"
                                        aria-label="Cancel"
                                      />
                                    }
                                  </p>
                                ))}
                            </div>
                          </div>

                          {/*<div className="text-center m-auto mt-[20px] h-[100px] overflow-auto">
                            <div className="grid grid-cols-2 md:grid-cols-2 gap-3 xl:gap-[0.250vw]">
                              {fileName?.length > 0 &&
                                fileName.map(res => (
                                  <p className="psa-attachments-notes-remove-btn text-[12px] h-[30px]">
                                    {res}{" "}
                                    {
                                      <Button
                                        icon="pi pi-times"
                                        onClick={() => {
                                          setFileName(prev => {
                                            return prev.filter(res1 => {
                                              if (res1 != res) {
                                                return res1;
                                              }
                                            });
                                          });
                                        }}
                                        rounded
                                        text
                                        severity="danger"
                                        aria-label="Cancel"
                                      />
                                    }
                                  </p>
                                ))}
                            </div>
		  </div> */}

                          {partyDocuments?.length === 0 ? (
                            <div class="text-center p-10 absolute top-0 right-0 left-0 m-auto">
                              <h4>
                                Drop files anywhere to upload
                                <br />
                                or
                              </h4>
                              <p class="">Select Files</p>
                            </div>
                          ) : (
                            <div class="text-center p-10 absolute top-0 right-0 left-0 m-auto">
                              {partyDocuments?.length && docList?.length === 0
                                ? partyDocuments.map((res, index) => {
                                  return (
                                    <>
                                      <a
                                        href={"#"}
                                        onClick={() => {
                                          res?.filepath && OpenDocument(res?.filepath);
                                        }}
                                        target="_blank"
                                      >
                                        {res?.filename}
                                      </a>
                                      {
                                        <Button
                                          icon="pi pi-times"
                                          onClick={() => {
                                            onClickRemoveDoc(index);
                                            // setFileName(prev => {
                                            //   return prev.filter(res1 => {
                                            //     if (res1 != res) {
                                            //       return res1;
                                            //     }
                                            //   });
                                            // });
                                          }}
                                          rounded
                                          text
                                          severity="danger"
                                          aria-label="Cancel"
                                        />
                                      }
                                    </>
                                  );
                                })
                                : null}
                            </div>
                          )}
                        </div>


                      </div>
                    </div>

                    {tab3 ? null : (
                      <div className="flex flex-wrap items-center justify-center md:justify-end xl:gap-[0.521vw] gap-[8px] mt-10">
                        <div
                          className="inline-block text-white text-[16px] xl:text-[0.833vw] font-medium bg-[#113699] hover:bg-[#0f296e] border border-[#113699] hover:border-[#0f296e] rounded-[8px] xl:rounded-[0.417vw] py-[10px] xl:py-[0.521vw] px-[18px] xl:px-[0.938vw] cursor-pointer"
                          onClick={() => {
                            console.log("🚀 ~ file: index.js:183 ~ saveSelectedReport ~ party: 👍👍👍👍", party);
                            console.log(
                              "🚀 ~ file: index.js:182 ~ saveSelectedReport ~ psaDetail: 👍👍👍👍",
                              psaDetail
                            );
                            if (party === "" || party === null || psaDetail.submittedTo === "") {
                              toast.error("Please enter PSA Consultant's Name");
                              return;
                            }
                            //else if (clientId === '' || clientId === null ) { toast.error('Please enter clientId'); return; }
                            // else if (email === "" || email === null || email === undefined) {
                            //   toast.error("Please enter email");
                            //   return;
                            // }
                            setTab1(false);
                            setTab2(true);
                            setTab3(false);
                          }}
                        >
                          <span>Next</span>
                        </div>
                        {/* <div className='xl:py-[0.833vw] py-[14px] xl:px-[1.458vw] px-[24px] text-[#101828] rounded-lg font-semibold text-sm xl:text-[0.833vw] space-x-2 cursor-pointer'><i className='gusd-close text-xs'></i><span>Cancel</span></div>
                    <div className='xl:py-[0.833vw] py-[14px] xl:px-[1.458vw] px-[24px] text-[#D92D20] rounded-lg font-semibold text-sm xl:text-[0.833vw] space-x-2 cursor-pointer'><i className='gusd-close-circle-bold text-base'></i><span>Reject</span></div>
                    <div className='xl:py-[0.833vw] py-[14px] xl:px-[1.458vw] px-[24px] bg-[#113699] text-white rounded-lg font-semibold text-sm xl:text-[0.833vw] space-x-2 cursor-pointer'><i className='gusd-check-circle text-sm'></i><span>Confirm</span></div>
				*/}
                      </div>
                    )}

                    {/*</form>  */}
                  </div>
                  {/*form*/}
                </div>
              </div>
              {/*Col-8*/}
            </>
          ) : tab2 ? (
            <Termsandcondition
              setTab1={setTab1}
              setTab2={setTab2}
              checked={checked}
              checked1={checked1}
              checked2={checked2}
              checked3={checked3}
              checked4={checked4}
              checked5={checked5}
              setChecked={setChecked}
              setChecked1={setChecked1}
              setChecked2={setChecked2}
              setChecked3={setChecked3}
              setChecked4={setChecked4}
              setChecked5={setChecked5}
              setTab3={setTab3}
              setStrs={setStrs}
              strs={strs}
              calpers={calpers}
              setCalpers={setCalpers}
              selectedFileName={selectedFileName}
              setSelectedFileName={setSelectedFileName}
              selectedFileNames={selectedFileNames}
              setSelectedFileNames={setSelectedFileNames}
              setSelectedFileNameData={setSelectedFileNameData}
              setSelectedFileNamesData={setSelectedFileNamesData}
            />
          ) : tab3 ? (
            <Preview
              psaDetail={psaDetail}
              partyName={isPartyNameChange ? party : psaDetail.submittedTo ? psaDetail.submittedTo : "----"}
              // partyName={psaDetail.submittedTo ? psaDetail.submittedTo : party}
              typeBE={typeBE}
              otherTypeBE={otherTypeBE}
              title={title}
              city={city}
              address={address}
              zip={zip}
              pocName={pocName}
              state={state}
              license={license}
              pocNumber={pocNumber}
              ssn={ssn}
              employerId={employerId}
              setTab1={setTab1}
              setTab2={setTab2}
              setTab3={setTab3}
              id={id}
              rejectSelectedReport={rejectSelectedReport}
              saveSelectedReport={saveSelectedReport}
              pleaseWaitBtn={pleaseWaitBtn}
              buttonClicked={buttonClicked}
              strs={strs}
              calpers={calpers}
              initiatorDocuments={initiatorDocuments}
              OpenDocument={OpenDocument}
            />
          ) : null}

          <Dialog
            header=""
            visible={confirmVisible}
            style={{ width: "30vw" }}
            closable={false}
            onHide={() => {
              setConfirmVisible(false);
            }}
            footer={footerContentforPSA}
          >
            <p className="m-0 text-[#0487C8] text-center">
              <i className="mr-2 pi pi-check-circle"></i>
              <span className="font-medium text-[18px]">This report is Updated</span>
            </p>
          </Dialog>
        </div>
      ) : isLoading ? (
        <div className="card flex justify-content-center">
          <ProgressSpinner
            style={{ width: "50px", height: "50px" }}
            strokeWidth="5"
            fill="var(--surface-ground)"
            animationDuration="2s"
          />
        </div>
      ) : (
        <div className="col-span-9">
          <div className="lg:px-[5.573vw] px-[80px] xl:py-[1.667vw] py-[30px]">
            {/*form*/}
            <div
              className="text-[#000000] font-bold xl:text-[1.406vw] text-[24px]"
              data-aos="fade-down"
              data-aos-duration="700"
              data-aos-delay="500"
            >
              Verify OTP
            </div>

            <div
              className="xl:mt-[1.667vw] mt-[25px] "
              data-aos="fade-down"
              data-aos-duration="700"
              data-aos-delay="500"
            >
              {/* <form> */}
              <div className="grid  xl:gap-[1.250vw] gap-[20px] ">
                {/*col*/}
                <div className="space-y-1" style={{ width: "50%", margin: "auto" }}>
                  <div>
                    <label className="text-[#344054] font-medium text-xs">
                      OTP<span className="text-[red] pl-0.2">*</span>
                    </label>
                  </div>
                  <div>
                    <input
                      type="text"
                      name="otp"
                      onChange={e => {
                        formik.setFieldValue("otp", e.target.value);
                      }}
                      value={formik.values.otp}
                      placeholder="Enter OTP"
                      className="bg-white border border-[#E4E7EC] rounded-[5px] xl:h-[2.292vw] h-[40px] xl:p-[0.625vw] p-[10px] placeholder:text-[#667085] placeholder:text-xs w-full leading-10"
                    />
                  </div>
                  <div
                    style={{ marginTop: "20px" }}
                    className="flex flex-wrap items-center justify-center md:justify-start xl:gap-[0.521vw] gap-[8px]"
                  >
                    <button
                      onClick={() => {
                        formik.handleSubmit();
                      }}
                      disabled={buttonClicked}
                      className="xl:py-[0.833vw] py-[14px] xl:px-[1.458vw] px-[24px] bg-[#113699] text-white rounded-lg font-semibold text-sm xl:text-[0.833vw] space-x-2 cursor-pointer"
                    >
                      {" "}
                      <i className="gusd-check-circle text-sm"></i>
                      <span>Verify OTP</span>
                    </button>
                  </div>
                </div>
                {/*col*/}
              </div>

              {/*</form>  */}
            </div>
            {/*form*/}
          </div>
        </div>
      )}
    </>
  );
}
